prettyprint = require('code-prettify');
require('./projects');
require('./envision/demos');
require('./envision/documentation');
require('./flotr2/documentation');
require('./flotr2/driver');

PR.prettyPrint();
